
<GenAILayout class="intent-selection">
  <cvt-left-side-bar class="marketplace-left-nav-bar intent-sidebar">
    <cvt-button :loading="loading" class="back-btn" text="" icon="arrow-left" @click="goToLandingPageGoal" />
    <h2 class="title mt-2">{{ $t('gen_ai.intent.title') }}</h2>
    <p class="description">{{ $t('gen_ai.intent.description') }}</p>
    <div class="intents">
      <div v-for="intentGoal in intentGoals" :key="intentGoal.value" class="intent">
        <cvt-custom-radio
          name="intentGoal"
          font-size="13px"
          color="#5d62ab"
          :checked="intentGoal.value === selectedIntentGoal?.value"
          :label="intentGoal.label"
          :disabled="loading"
          @change="() => handleChange(intentGoal)"
        />
      </div>
    </div>
    <cvt-button
      v-if="selectedIntentGoal"
      :loading="loading"
      class="bottom-btn"
      :text="$t('gen_ai.intent.continue_btn')"
      icon="chevron-right"
      :prepend="false"
      @click="handleLoadContent"
    />
  </cvt-left-side-bar>
  <div class="content-wrapper">
    <div v-if="selectedIntentGoal" class="content">
      <h2>{{ $t('gen_ai.intent.continue_msg') }}</h2>
    </div>
  </div>
</GenAILayout>
